var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareUp = function SvgIconArrowSquareUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.48 7.372q.125.069.227.17l3.179 3.179a1 1 0 0 1-1.415 1.414L13 10.664v5.086a1 1 0 1 1-2 0v-5.085l-1.47 1.47a1 1 0 1 1-1.415-1.414l3.161-3.161A1 1 0 0 1 12 7.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48 7.372A1 1 0 0 0 12 7.25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 4.5c0-.966.784-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75zm2 .25v14.5h14.5V4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArrowSquareUp;